var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"flex flex-col items-center text-gray-600"},[_c('div',{staticClass:"my-2"},[_vm._v("Allematpriser.no")]),_c('div',{staticClass:"my-2"},[_vm._v(" "+_vm._s(_vm.gitSha)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }